const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBottomLeftWindow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 82",
    width: 38.23,
    height: 79.996,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--theme-secondary)"
    },
    d: "M 9.283 80.728 L 0.928 22.207 C -2.118 -1.86 34.979 -10.304 38.98 21.302 L 36.695 80.404 L 9.283 80.728 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.451,
    y: 378.776,
    width: 36.213,
    height: 3.714,
    style: {
      stroke: "var(--theme-secondary)",
      fill: "var(--theme-primary)"
    },
    transform: "matrix(0.999436, -0.033589, 0.033589, 0.999436, -219.86057, -344.654976)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.06,
    y: 378.776,
    width: 30.266,
    height: 3.714,
    style: {
      stroke: "var(--theme-secondary)",
      fill: "var(--theme-primary)"
    },
    transform: "matrix(0.999852, -0.017222, 0.017222, 0.999852, -174.757801, -316.429297)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.131,
    y: 378.776,
    width: 79.036,
    height: 3.714,
    style: {
      stroke: "var(--theme-secondary)",
      fill: "var(--theme-primary)"
    },
    transform: "matrix(0.050931, 0.998702, -0.998702, 0.050931, 376.327767, -474.750224)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomLeftWindow);
export default __webpack_public_path__ + "static/media/BottomLeftWindow.074fb185545c597c7aca82c5aa61ac22.svg";
export { ForwardRef as ReactComponent };